export const ALL_NETWORKS = Object.freeze({
  '-22': 'Media.net',
  '-20': 'DistrictM',
  '-19': 'MoPub',
  '-18': 'LiveRail',
  '-17': 'EQWorks',
  '-16': 'GumGum',
  '-15': 'SpotX',
  '-14': 'BrightRoll',
  '-13': 'AdConducto',
  '-12': 'Smaato',
  '-11': 'ONE by AOL',
  '-10': 'Yahoo RMX',
  '-9': 'Index',
  '-8': 'Rubicon',
  '-7': 'AppNexus',
  '-6': 'OpenX',
  '-5': 'PulsePoint',
  '-4': 'Adbrite',
  '-3': 'Pubmatic',
  '-2': 'Admeld',
  '-1': 'Google',
})

// subset of ALL_NETWORKS that we use for manage.targeting
export const NETWORKS = Object.freeze({
  '-9': 'Index',
  '-8': 'Magnite (Rubicon)',
  '-22': 'Media.net',
})

export function getNetwork(code) {
  return ALL_NETWORKS[code] || 'Unknown Type'
}

export default {
  ALL_NETWORKS,
  NETWORKS,
  getNetwork,
}
